/**
 * Where `/login?redirect=` may send someone: a page on this site, or home.
 *
 * The URL parser decides, not a pattern, because it reads the value exactly as the browser will
 * (`/\host` and `/<tab>/host` both become `//host`, another site).
 */
export function safeRedirect(raw: string | null, origin: string): string {
  if (!raw || !raw.startsWith('/')) return '/';
  try {
    const url = new URL(raw, origin);
    return url.origin === origin ? url.pathname + url.search + url.hash : '/';
  } catch {
    return '/';
  }
}
